import React, { useState } from "react";
import styled from "styled-components";

import ChevronLeft from "../../../assets/icons/chevron-left.svg";
import ChevronRight from "../../../assets/icons/chevron-right.svg";
import CloseBtn from "../../../assets/icons/x-close.svg";
const StyledDiv = styled.div`
    &.popup-guideline-container {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 32px 24px;
        background-color: #1e2631;
        border-radius: 4px;
        width: 1000px;
        height: 695px;
        justify-content: space-between;
        position: relative;
    }

    .mmain-grouoed-popup {
        display: flex;
        flex-direction: column;
        gap: 32px;
        justify-content: center;
        align-items: center;
    }

    .guideline-title {
        font-size: 20px;
        font-weight: 700;
    }
    .grouped-title-desc {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 100%;
        align-items: center;
    }

    .arrow-navigation {
        height: 32px;
        width: 32px;
        background: #1a222d;
        border-radius: 50px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .navigation-pointer {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
    }
    .navigate-dot {
        height: 14px;
        width: 14px;
        background: #262e3e;
        border-radius: 50px;
        cursor: pointer;
    }
    .navigate-dot.active {
        background: #ff9900;
    }
    .guideline-description {
        width: 850px;
        height: 522px;
        box-shadow: -6px -12px 20px 12px #1a222d;
    }
    img.guideline-description-img {
        height: 100%;
        width: 100%;
    }
    img.x-close-po {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
    }
`;
export default function GuidelinePopup({ data = [], closeGuidelinePopup }) {
    const [current, setCurrent] = useState(0);

    const goPrev = () => setCurrent(c => (c > 0 ? c - 1 : c));
    const goNext = () => setCurrent(c => (c < data.length - 1 ? c + 1 : c));
    const goTo = idx => setCurrent(idx);

    const currentStep = data[current] || {};

    return (
        <StyledDiv className="popup-guideline-container">
            <div className="mmain-grouoed-popup">
                <div className="guideline-title">{currentStep.title}</div>
                <div className="grouped-title-desc">
                    <div className="arrow-navigation" onClick={goPrev} style={{ opacity: current === 0 ? 0.5 : 1 }}>
                        <img src={ChevronLeft} alt="guideline" className="arrow-navigation-left" />
                    </div>
                    <div className="guideline-description">
                        <img
                            src={currentStep.backgroundImg || ""}
                            alt="guideline"
                            className="guideline-description-img"
                        />
                    </div>
                    <div
                        className="arrow-navigation"
                        onClick={goNext}
                        style={{ opacity: current === data.length - 1 ? 0.5 : 1 }}>
                        <img src={ChevronRight} alt="guideline" className="arrow-navigation-right" />
                    </div>
                </div>
            </div>
            <div className="navigation-pointer">
                {data.map((_, idx) => (
                    <div
                        key={idx}
                        className={`navigate-dot${idx === current ? " active" : ""}`}
                        onClick={() => goTo(idx)}></div>
                ))}
            </div>
            <img className="x-close-po" src={CloseBtn} alt="" onClick={closeGuidelinePopup} />
        </StyledDiv>
    );
}
